import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-timer-icon',
    templateUrl: './timer-icon.component.html',
    styleUrls: ['./timer-icon.component.scss']
})
export class TimerIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
